var _rect, _path, _path2, _path3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLazadaIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 624.3 624.3",
    enableBackground: "new 0 0 624.3 624.3",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 305.8847,
    y1: -453.5474,
    x2: 313.9513,
    y2: 635.428,
    gradientTransform: "matrix(1 0 0 1 0 -80.11)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3379,
    style: {
      stopColor: "#5B8BEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7794,
    style: {
      stopColor: "#2742A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#112283"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#SVGID_1_)",
    width: 624.3,
    height: 624.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g942",
    transform: "matrix(1.3719271,0,0,1.3719271,169.4857,-38.493576)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g71",
    transform: "matrix(3.3097462,0,0,3.3097462,-688.02908,65.088537)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "path69_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 189.5344,
    y1: 170.1424,
    x2: 279.1699,
    y2: 170.8368,
    gradientTransform: "matrix(114.8374 0 0 -114.8374 -21581.2324 19599.6074)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 9.999999e-8,
    style: {
      stopColor: "#FFB900"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3376,
    style: {
      stopColor: "#F38000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5673,
    style: {
      stopColor: "#F83C72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#FC1CBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#FE08ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF00FF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path69",
    fill: "url(#path69_1_)",
    d: "M239.6,105.7c-0.8,0-1.6-0.2-2.2-0.6c-5.9-3.4-49.4-30.7-51-31.5 c-1.2-0.6-2.1-1.8-2.2-3.2V32.2c0-1.4,0.7-2.8,1.9-3.6l0.3-0.2c4.2-2.6,18.3-11.2,20.5-12.4c0.5-0.3,1.1-0.5,1.7-0.5 c0.6,0,1.1,0.2,1.6,0.4c0,0,19.7,12.8,22.7,14c2.1,1,4.4,1.5,6.8,1.4c2.6,0.1,5.2-0.6,7.6-1.8c3-1.6,21.8-13.5,22-13.5 c0.5-0.3,1-0.4,1.6-0.4s1.2,0.2,1.7,0.5c2.6,1.4,20,12.1,20.8,12.6c1.2,0.7,2,2.1,2,3.5v38.2c-0.1,1.4-1,2.6-2.2,3.2 c-1.6,0.9-45,28.2-51,31.5C241.2,105.5,240.4,105.7,239.6,105.7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g79",
    transform: "matrix(3.3097462,0,0,3.3097462,-688.02908,65.088537)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "path77_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 189.8032,
    y1: 169.829,
    x2: 281.1905,
    y2: 220.4294,
    gradientTransform: "matrix(114.8374 0 0 -114.8374 -21581.2324 19599.6074)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE0A3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EE0A3F",
      stopOpacity: 0
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path77",
    fill: "url(#path77_1_)",
    d: "M239.4,105.7h0.2c0.8,0,1.6-0.2,2.2-0.6c5.9-3.4,49.3-30.7,51-31.5 c1.3-0.6,2.1-1.8,2.2-3.2V32.2c0-0.7-0.1-1.3-0.4-1.9l-55.3,30.4L239.4,105.7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g970",
    transform: "matrix(-3.2744849,0,0,3.2744849,-467.18522,65.934126)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "path968_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -47.8267,
    y1: 171.4726,
    x2: -3.1901,
    y2: 207.4298,
    gradientTransform: "matrix(-111.2069 0 0 -111.2069 -5467.0049 19137.0176)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ED6600"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F98200"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path968",
    fill: "url(#path968_1_)",
    d: "M-174.4,106h0.2c0.8,0,1.6-0.2,2.2-0.6c5.9-3.4,49.3-30.7,51-31.5 c1.3-0.6,2.1-1.8,2.2-3.2V32.6c0-0.7-0.1-1.3-0.4-1.9l-55.3,30.4V106"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "g35_1_",
    transform: "matrix(12.509277,0,0,12.509277,438.06846,8.29825)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path33_1_",
    fill: "#FFFFFF",
    d: "M-19.7,19.6h1.8v8.8h3.2v1.7h-5V19.6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g41_1_",
    transform: "matrix(12.509277,0,0,12.509277,438.06846,8.29825)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path39_1_",
    fill: "#FFFFFF",
    d: "M-10.5,22.3c1,0,1.9,0.4,2.5,1.2v-1h1.7v7.8H-8v-1c-0.6,0.8-1.5,1.2-2.5,1.2 c-2.1,0-3.7-1.8-3.7-4C-14.2,24.1-12.6,22.3-10.5,22.3 M-10.2,23.8c-1.4,0-2.3,1.1-2.3,2.5s0.9,2.5,2.3,2.5s2.3-1.1,2.3-2.5 S-8.8,23.8-10.2,23.8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g47_1_",
    transform: "matrix(12.509277,0,0,12.509277,438.06846,8.29825)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path45_1_",
    fill: "#FFFFFF",
    d: "M-5,28.9l4.1-4.9h-4v-1.5h6.2v1.4l-4,4.8h4.1v1.5H-5V28.9"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLazadaIcon);
export default __webpack_public_path__ + "static/media/lazada_icon.5dfee8bd1d3461393a5365b2988dfad5.svg";
export { ForwardRef as ReactComponent };